// extracted by mini-css-extract-plugin
export default {"content-wrapper-text":"ContentWrapperText_content-wrapper-text__vTzgk","medium":"ContentWrapperText_medium__szRsf","small":"ContentWrapperText_small__SK+bI"};